import { AuthenticationData } from "../components/pnl-chatbot-container/models/authentication.models";
import { readCookie } from "./cookie.service";

export const businessPortal = 'businessportal';
export const identity = 'identity';

export function createParam(authData: AuthenticationData, defaultLanguage: string, customerFirstName: string,
    customerMiddleName: string, customerLastName: string, customerEmail: string, barcode: string,
    postalCode: string, countryCode: string, businessUserId: string, businessPortalName: string,
    businessModuleName: string, businessCustomerId: string, businessPhoneNumber: string, companyName: string,
    authenticationToken: string, caseDetailsApiUrl: string, caseId: string, caseStatus: string,
    caseTitle: string, caseDescription: string, orderNumber: string, visitorId: string, loginEnabled: boolean): any {
    const profileCloudCookieId = readCookie('pnl_pid');
    var data = {
        cookieId: profileCloudCookieId,
        pageUrl: window.location.href
    } as any;

    data.authenticated = authData.authenticated;
   
    if (authData.authenticated) {
        data.accessToken = authData.accessToken;
    }

    if (authData.portal === identity) {
        data.consumerUser = true;
    }

    if (authData.portal === businessPortal) {
        data.businessUser = true;
    }

    if (defaultLanguage) {
        data.defaultLanguage = defaultLanguage;
    }

    if (customerFirstName) {
        data.customerFirstName = customerFirstName;
    }

    if (customerMiddleName) {
        data.customerMiddleName = customerMiddleName;
    }

    if (customerLastName) {
        data.customerLastName = customerLastName;
    }

    if (customerEmail) {
        data.customerEmail = customerEmail;
    }

    if (barcode) {
        data.barcode = barcode;
    }

    if (postalCode) {
        data.postalCode = postalCode;
    }

    if (countryCode) {
        data.countryCode = countryCode;
    }

    if (businessUserId) {
        data.businessUserId = businessUserId;
    }

    if (businessPortalName) {
        data.businessPortalName = businessPortalName;
    }

    if (businessModuleName) {
        data.businessModuleName = businessModuleName;
    }

    if (businessCustomerId) {
        data.businessCustomerId = businessCustomerId;
    }

    if (businessPhoneNumber) {
        data.businessPhoneNumber = businessPhoneNumber;
    }

    if (companyName) {
        data.companyName = companyName;
    }

    if (authenticationToken) {
        data.authenticationToken = authenticationToken;
    }

    if (caseDetailsApiUrl) {
        data.caseDetailsApiUrl = caseDetailsApiUrl;
    }

    if (caseId) {
        data.caseId = caseId;
    }

    if (caseStatus) {
        data.caseStatus = caseStatus;
    }

    if (caseTitle) {
        data.caseTitle = caseTitle;
    }

    if (caseDescription) {
        data.caseDescription = caseDescription;
    }

    if (orderNumber) {
        data.orderNumber = orderNumber;
    }

    if (visitorId) {
        data.visitorId = visitorId;
    }

    data.loginEnabled = loginEnabled;

    return data;
}
